<template>
    <div class="row row--checkbox">
        <div class="inputWrap">
            <input type="checkbox"
                   :name="name"
                   :id="id"
                   :disabled="disabled"
                   @change="handleChange"
                   :checked="checked"
                   :value="value"
                   v-model="enabled"
            />
            <label :for="id">
                {{ label }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        id: {
            type: String
        },
        label: {
            type: String
        },
        name: {
            type: String,
        },
        value: {
            type: [String, Number]
        }
    },
    data() {
        return {
            enabled: this.checked,
        }
    },
    methods: {
        handleChange(e) {
            // this.stateValue = e.target.value;
            this.$emit('filter-update', {
                enabled: this.enabled,
                event: e,
                value: this.value
            });
        }
    },
    watch: {
        checked(value, oldValue) {
            if (value !== oldValue) {
                return this.enabled = value;
            }
        }
    }
}
</script>